import React from "react";
import { Container } from "react-bootstrap";

const MainMenu = (props) => {
  const { children } = props;
  return (
    <Container fluid style={{ padding: "0" }}>
      {children}
    </Container>
  );
};

export default MainMenu;
